export default __webpack_public_path__ + "static/threeds-999bb41e4d24de2543c8b9d4bfd74656.png";